import React from "react";
import styles from "./viewer-placeholder.module.scss";
import { useI18N } from "@src/language/language-context";

interface ViewerPlaceholderProps {
  // `no-dashboards` — the list endpoint returned an empty array: no dashboard
  // has ever been created in this namespace.
  // `no-default` — dashboards exist, but none of them is flagged as default.
  // `draft` — the URL named a dashboard that is not published.
  variant: "no-dashboards" | "no-default" | "draft";
}

const cssClassName = "viewer-placeholder";

// Viewer-only single-line placeholder for the canvas. It lives outside the
// editor's components so the read-only page never borrows editor vocabulary:
// the reader has no dashboard list to select from and no way to create one, so
// the editor's "create or select a dashboard" copy would point at UI that does
// not exist on this page.
export const ViewerPlaceholder = ({ variant }: ViewerPlaceholderProps) => {
  const i18n = useI18N();

  const text =
    variant === "no-dashboards"
      ? i18n("pages.dashboardsPage.noDashboards")
      : variant === "draft"
      ? i18n("pages.dashboardsPage.draftDashboard")
      : i18n("pages.dashboardsPage.noDefaultDashboard");

  return (
    <div className={styles[cssClassName]}>
      <p className={styles[`${cssClassName}__message`]}>{text}</p>
    </div>
  );
};
